import * as Yup from "yup";

const ParcelCategoryValidationSchema =
  Yup.object().shape({
    name: Yup.string().required(
      "Name is required."
    ),

    allowedVehicles: Yup.array()
      .of(Yup.string())
      .min(
        1,
        "Select at least one allowed vehicle."
      ),

    basePrice: Yup.number()
      .required(
        "Base price is required."
      )
      .min(
        0,
        "Base price cannot be negative."
      ),

    weightCharge: Yup.number()
      .required(
        "Weight charge is required."
      )
      .min(
        0,
        "Weight charge cannot be negative."
      ),

    vehiclePerKmPrice:
      Yup.object().shape({
        bike: Yup.number().min(
          0,
          "Bike per km price cannot be negative."
        ),

        van: Yup.number().min(
          0,
          "Van per km price cannot be negative."
        ),

        truck: Yup.number().min(
          0,
          "Truck per km price cannot be negative."
        ),

        any: Yup.number().min(
          0,
          "Any vehicle per km price cannot be negative."
        ),
      }),

    minWeight: Yup.number()
      .required(
        "Minimum weight is required."
      )
      .min(
        0,
        "Minimum weight cannot be negative."
      ),

    maxWeight: Yup.number()
      .required(
        "Maximum weight is required."
      )
      .min(
        Yup.ref("minWeight"),
        "Maximum weight must be greater than or equal to minimum weight."
      ),

    isActive: Yup.boolean(),
  });

export default ParcelCategoryValidationSchema;